import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PatientListService {
  indeterminate = new Subject<void>();

  constructor() {
    // Nada
  }
}
